import "./ResultBar.css";
import React, { Component } from "react";
import ResultItem from "../ResultItem/ResultItem";
import Tree from "../Tree/Tree";

class ResultBar extends Component {
  state = {
    menuItems: [
      {
        id: "0",
        item: "0",
        ordre: 1,
        isExpanded: false,
        isChecked: true,
        childs: [
          {
            id: "1",
            item: "1",
            ordre: 1,
            isChecked: true,
            childs: [],
          },
          {
            id: "2",
            item: "2",
            ordre: 1,
            isChecked: false,
            childs: [],
          },
        ],
      },
      {
        id: "3",
        item: "3",
        ordre: 1,
        isChecked: true,
        childs: [],
      },
      {
        id: "4",
        item: "4",
        ordre: 1,
        isChecked: false,
        isExpanded: true,
        childs: [
          {
            id: "5",
            item: "5",
            ordre: 1,
            isChecked: false,
            isExpanded: true,
            childs: [
              {
                id: "6",
                item: "6",
                ordre: 1,
                isChecked: false,
                childs: [
                  {
                    id: "7",
                    item: "7",
                    ordre: 1,
                    isChecked: false,
                    childs: [
                      {
                        id: "8",
                        item: "8",
                        ordre: 1,
                        isChecked: false,
                        childs: [],
                      },
                      {
                        id: "9",
                        item: "9",
                        ordre: 1,
                        isChecked: false,
                        childs: [],
                      },
                    ],
                  },
                ],
              },
              {
                id: "10",
                item: "10",
                ordre: 1,
                isChecked: false,
                childs: [],
              },
            ],
          },
        ],
      },
    ],
    sideDrawerOpen: false,
  };

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="leftCol">
            <div className="leftContainerResultBar">
              <Tree menuItems={this.state.menuItems} />
            </div>
          </div>
          <div className="rightCol">
            <div className="rightContainerResultBar">
              <ResultItem />
              <ResultItem />
              <ResultItem />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResultBar;
